jQuery(document).ready(function(){
    if (jQuery('.hero-banner-dynamictext .fade_section').length) {
        var current = 0;
        var num_options = jQuery('.hero-banner-dynamictext .fade_section').length;
        var freq = 2000;
        var fade_element_array = jQuery('.hero-banner-dynamictext .fade_section');

        function fadein(x) {
            fade_element_array.eq(x).stop().fadeIn(600);
        }

        function fadeout(x) {
            fade_element_array.eq(x).stop().fadeOut(300);
        }

        function fade() {
            fadeout(current);
            current = current + 1;
            if (current >= num_options) {
                current = 0;
            }
            fadein(current);
        }
        setInterval(fade, freq);
    }

    function adjustFadeSectionHeight() {
        var maxHeight = 0;
        jQuery('.hero-banner-dynamictext .fade_section').each(function() {
            var sectionHeight = jQuery(this).height();
            if (sectionHeight > maxHeight) {
                maxHeight = sectionHeight;
            }
        });
        jQuery('.hero-banner-dynamictext .fade_section_con').height(maxHeight);
    }

    jQuery(window).on('resize', function() {
        adjustFadeSectionHeight();
    });


    adjustFadeSectionHeight();
    
});